<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.5 8H14.5" stroke="currentColor"/>
<path d="M8 1.5V14.5" stroke="currentColor"/>
</svg>
